"use client";

import type { FC } from "react";
import { cn } from "../../utils";
import useSlider from "./hooks/useSlider";
import { sliderIndicatorsVariants } from "./variants";

type Props = {
  className?: string;
  indicatorClassName?: string;
  placement?: "overlay" | "below";
  slideLabel?: string;
};

const SliderIndicators: FC<Props> = ({
  className,
  indicatorClassName,
  placement = "overlay",
  slideLabel = "Go to slide",
}) => {
  const { itemCount, firstVisibleIndex, scrollToIndex } = useSlider();

  return (
    <div
      data-slot="slider-indicators"
      className={cn(sliderIndicatorsVariants({ placement }), className)}
    >
      {Array.from({ length: itemCount }, (_, index) => index).map((index) => (
        <button
          key={index}
          type="button"
          data-slot="slider-indicator"
          data-active={index === firstVisibleIndex ? "true" : undefined}
          aria-label={`${slideLabel} ${index + 1}`}
          aria-current={index === firstVisibleIndex}
          onClick={() => scrollToIndex(index)}
          className={cn(
            "mx-1 size-2 rounded-full bg-border data-active:bg-primary",
            indicatorClassName,
          )}
        />
      ))}
    </div>
  );
};

export default SliderIndicators;
